module.exports = __webpack_public_path__ + "static/media/widthAuto.928b06a7.jpg";